import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';

import { useDemo, useCustomSearchParams, useSignalR, useErrors, useTheme } from 'src/hook';

import { ERequestStatus } from 'src/api/enumRequest';
import { AppProvider } from 'src/context/AppContext';

import { selectStatusGetPayment } from 'src/store/slice/payment/state';

import PopupExpiredPayment from 'src/components/popups/popupExpiredPayment';
import PopupCompletedPayment from 'src/components/popups/popupCompletedPayment';
import PopupErrorPayment from 'src/components/popups/popupErrorPayment';
import PopupRejectedPayment from 'src/components/popups/popupRejectedPayment';

import PopupLoader from 'src/components/popups/popupLoader';

import MerchantInfo from './components/merchantInfo';
import CurrencyDetails from 'src/components/currencyDetails';
import Address from 'src/components/address';
import CurrencyFee from 'src/components/currencyFee';
import Transactions from './components/transactions';

import './widget.scss';

export interface ISelectedCurrency {
  payment_id: string;
  currency_id: string;
  network: string;
}

const Widget: React.FC = (): JSX.Element => {
  const { isDemo, theme, integrated } = useCustomSearchParams();

  const statusGetPayment = useSelector(selectStatusGetPayment);

  const [isShowMainLoader, setShowMainLoader] = useState(true);

  useDemo();
  useSignalR();
  useErrors();
  useTheme(theme);

  useEffect(() => {
    if (integrated) {
      document.body.classList.add(`integrated`);
    }

    return () => document.body.classList.remove(`integrated`);
  }, [integrated]);

  /**
   * useEffect hide main loader when got payment or demo mode is one
   */
  useEffect(() => {
    if (statusGetPayment === ERequestStatus.success || isDemo) {
      setShowMainLoader(false);
    }
  }, [statusGetPayment, isDemo]);

  return (
    <AppProvider>
      <MerchantInfo />
      <CurrencyFee />
      <CurrencyDetails />
      <Address />

      <Transactions />

      <PopupCompletedPayment />
      <PopupExpiredPayment />
      <PopupErrorPayment />
      <PopupRejectedPayment />

      <PopupLoader visible={isShowMainLoader} />
      <ToastContainer />
    </AppProvider>
  );
};

export default Widget;
